import React, { useState, useEffect } from 'react';
import Menu from '../Menu'; // Assuming you have a Menu component

const ClientsPage = () => {
  const [socket, setSocket] = useState(null);
  const [clients, setClients] = useState([]);
  const [allMsg, setAllMsg] = useState("");
  const [messageLog, setMessageLog] = useState([]);

  useEffect(() => {
    const ws = new WebSocket("ws://157.90.147.8:9500");
    setSocket(ws);

    ws.onopen = () => {
      console.log("WebSocket connected");
    };

    ws.onmessage = (event) => {
      const parsedData = JSON.parse(event.data);
      if (parsedData.action === "clientsmap") {
        setClients(parsedData.data);
      }
      setMessageLog((prev) => [...prev, { type: "received", data: parsedData }]);
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket closed");
    };

    return () => {
      ws.close();
    };
  }, []);

  const getClientsMap = () => {
    if (socket) {
      const data = { Action: "getclientsmap" };
      socket.send(JSON.stringify(data));
      setMessageLog((prev) => [...prev, { type: "sent", data }]);
    }
  };

  const sendMessageToAll = () => {
    const data = { Action: "message", target: "all", Msg: allMsg };
    socket.send(JSON.stringify(data));
    setMessageLog((prev) => [...prev, { type: "sent", data }]);
    setAllMsg(""); // Clear the input after sending
  };

  const sendMessageToClient = (clientKey, message) => {
    const data = { Action: "message", target: clientKey, Msg: message };
    socket.send(JSON.stringify(data));
    setMessageLog((prev) => [...prev, { type: "sent", data }]);
    document.getElementById(`msg-${clientKey}`).value = ""; // Clear after sending
  };

  const clearLog = () => {
    setMessageLog([]); // Clear the message log
  };

  return (
    <>
      <Menu /> {/* Sidebar menu included */}
      <div className="content-wrapper" style={{ padding: '20px' }}>

        {/* Button to get client map */}
        <button className="btn btn-primary" onClick={getClientsMap} style={{ width: '15%', marginBottom: '20px' }}>
          Get Client Map
        </button>

        {/* Clear Log Button */}
        <button className="btn btn-danger" onClick={clearLog} style={{ width: '15%', marginLeft: '20px', marginBottom: '20px' }}>
          Clear Log
        </button>

        {/* Message Log Box */}
        <div style={{ backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '5px', maxHeight: '300px', overflowY: 'scroll', border: '1px solid #ddd' }}>
          {messageLog.length === 0 ? (
            <p>No logs available</p>
          ) : (
            <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
              {messageLog
                .filter(log => log.data.Action === "message") // Only show logs related to "message" action
                .map((log, index) => (
                  <li key={index} style={{ marginBottom: '10px' }}>
                    <strong>{log.type === 'sent' ? 'Sent' : 'Received'}:</strong>{' '}
                    <pre style={{ display: 'inline' }}>
                      {`Target: ${log.data.target || 'all'}, Message: ${log.data.Msg}`}
                    </pre>
                  </li>
              ))}
            </ul>
          )}
        </div><br></br>

        {/* Input and button to send message to all clients */}
        <div className="form-group">
          <label>Message to All:</label>
          <input
            type="text"
            className="form-control"
            value={allMsg}
            onChange={(e) => setAllMsg(e.target.value)}
          />
        </div>
        <button className="btn btn-warning" onClick={sendMessageToAll} style={{ width: '100%', marginBottom: '20px' }}>
          Send to All
        </button>

        {/* Table to list clients and send individual messages */}
        <h4>Client list</h4><br></br>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Client Key</th>
              <th>Message</th>
              <th>Send</th>
            </tr>
          </thead>
          <tbody>
            {clients.length > 0 ? (
              clients.map((clientKey, index) => (
                <tr key={index}>
                  <td>{clientKey}</td>
                  <td>
                    <input type="text" id={`msg-${clientKey}`} className="form-control" />
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        sendMessageToClient(
                          clientKey,
                          document.getElementById(`msg-${clientKey}`).value
                        )
                      }
                    >
                      Send
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center' }}>
                  No clients connected
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
    </>
  );
};

export default ClientsPage;
